const endPoint = {
  // Prox endpoints
  authBuyer: '/v1/credit/accounts/management/commercial/prox/authbuyer',
  authBuyerProfile:
    '/v1/credit/accounts/management/commercial/prox/authbuyer-profile',
  authBuyerSummary: '/v1/credit/accounts/commercial/Prox/authbuyer-summary',
  authToken: '/v1/oauth2/token',
  businessProfile:
    '/v1/credit/accounts/management/commercial/prox/business-profile',
  checkUserExist: '/v1/commercial/identity/registration/users/verification',
  childAccountPrivilege: '/v1/commercial/identity/account/privilege',
  creditLimitIncreaseAuto:
    '/v1/credit/accounts/commercial/operations/creditlimit',
  creditLimitIncreaseAutoEligibility:
    '/v1/credit/accounts/commercial/operations/prox/creditlimitvalidator',
  csrAccountUpdate:
    '/v1/credit/accounts/management/commercial/prox/csr-notification',
  ebillEnrollment:
    '/v1/credit/accounts/management/commercial/prox/ebill-enrollments',
  ebillProfile: '/v1/credit/accounts/management/commercial/prox/ebill-profile',
  eBillStatement:
    '/v1/credit/accounts/management/commercial/prox/ebill-statement',
  eBillSummary: '/v1/credit/accounts/management/commercial/prox/ebill-summary',
  downTime: '/commercial/maintenance.json',
  intNetTerms: '/v1/credit/accounts/commercial/Prox/billPayEnrollments',
  invoiceDownload: '/v1/credit/accounts/commercial/Prox/invoice-download',
  invoicePrint: '/v1/credit/accounts/commercial/Prox/invoiceLookup',
  linkedAccounts: '/v1/commercial/identity/linked-accounts',
  messageDetail: '/v1/credit/prox/messages/content',
  messages: '/v1/credit/prox/messages/fetch',
  onlineUserList: '/v1/commercial/identity/online-users-list',
  onlineUserDetail: '/v1/commercial/identity/online-users',
  onlineUserPassword: '/v1/commercial/identity/online-users/password',
  onlineUserPrivilege: '/v1/commercial/identity/online-users/privilege',
  onlineUserMfaToggle: '/v1/credit/accounts/commercial/users/mfaOverrideUpdate',
  payment: '/v1/credit/accounts/commercial/prox/payments',
  paymentAccount: '/v1/credit/accounts/commercial/prox/payments/methods',
  replyMessage: '/v1/credit/prox/messages/reply',
  registrationPrivilege: '/v1/commercial/identity/registration/users/privilege',
  postLoginResetPasswordUpdate: '/v1/commercial/identity/user/password',
  sendMessage: '/v1/credit/prox/messages/send',
  shoppingCart: '/v1/credit/accounts/commercial/Prox/summary',
  skuDetail: '/v1/credit/accounts/commercial/Prox/invoiceLookup',
  switchLinkedAccount: '/v1/commercial/identity/linked-accounts/switch',
  transactions: '/v1/credit/accounts/management/commercial/prox/transactions',
  updateUserId: '/v1/commercial/identity/user/userid',
  userInfo: '/v1/credit/accounts/commercial/users/profiles',
  updateUserContactInfo: '/v1/credit/accounts/commercial/users/profileupdate',
  userAvailability: '/v1/commercial/identity/user',
  switchAccount: '/v1/credit/accounts/commercial/users/switch-account',

  // Brc endpoints
  accountSummary: '/v2/credit/accounts/summary',
  paymentMethod: '/v1/credit/billing/payments/methods',
  oneTimePayment: '/v1/credit/billing/payments',
  autoPay: '/v1/credit/billing/payments/autopay',
  autoPayHistory: '/v1/credit/billing/payments/autopay/history',
  closeAccount: '/v1/credit/accounts/management/close',
  lostCard: '/v1/credit/accounts/management/lost-stolen',
  recentActivity: '/v1/credit/accounts/transactions/recent',
  profileInfo: '/v1/credit/accounts/commercial/profile',
  additionalCard: '/v1/credit/accounts/commercial/cards/additional-cards',
  historicalActivity: '/v1/credit/accounts/transactions/historical',
  statementsInfo: '/v1/credit/accounts/statements',
  downloadStatements: '/v1/credit/accounts/commercial/transactions/historical',
  skuTransaction: '/v1/commercial/credit/accounts-invoice/lookup',

  // V3 Auth end points
  authTokenV3: '/v3/oauth2/token',
  getAuthCode: '/v2/commercial/identity/getauthcode',
  login: '/v2/commercial/identity/login/authenticate',
  recoverUserId: '/v2/commercial/identity/lookup-userid/eligibility/check',
  registrationEligibility:
    '/v2/commercial/identity/registration/eligibility-check',
  resetPasswordUpdate: '/v2/commercial/identity/reset-password/update',
  resetPasswordEligibilityCheck:
    '/v2/commercial/identity/reset-password/eligibility/check',
  saveFirstTimeLogin: '/v2/commercial/identity/registration/first-time-login',
  saveRegistration: '/v2/commercial/identity/registration/users'
}

export default endPoint
